export default theme => ({

  toolbar: {
    display: 'flex',
    justifyContent: 'space-between'
  },

  fullWidth: {
    width: '100%'
  }

});




// WEBPACK FOOTER //
// ./src/styles/components/TopPanel.js